var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 19.0304H13.8333V13.6971H19.1667V11.0304H13.8333V5.6971H11.1667V11.0304H5.83333V13.6971H11.1667V19.0304ZM3.16667 24.3638C2.43333 24.3638 1.80533 24.1029 1.28267 23.5811C0.760889 23.0584 0.5 22.4304 0.5 21.6971V3.03044C0.5 2.2971 0.760889 1.6691 1.28267 1.14644C1.80533 0.624658 2.43333 0.36377 3.16667 0.36377H21.8333C22.5667 0.36377 23.1947 0.624658 23.7173 1.14644C24.2391 1.6691 24.5 2.2971 24.5 3.03044V21.6971C24.5 22.4304 24.2391 23.0584 23.7173 23.5811C23.1947 24.1029 22.5667 24.3638 21.8333 24.3638H3.16667Z",
    fill: "#1374D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.01795dff283e124285344648c9e4a95c.svg";
export { ForwardRef as ReactComponent };